import { render, staticRenderFns } from "./MenuSubList.vue?vue&type=template&id=3fcc863c&scoped=true&"
import script from "./MenuSubList.vue?vue&type=script&lang=js&"
export * from "./MenuSubList.vue?vue&type=script&lang=js&"
import style0 from "./MenuSubList.vue?vue&type=style&index=0&id=3fcc863c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcc863c",
  null
  
)

export default component.exports